import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { CircularProgress, Box } from '@mui/material';

const RoleProtectedRoute = ({ requiredRole }: { requiredRole: string }) => {
  const { authenticated, loading, hasRole } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!authenticated) return <Navigate to="/login" replace />;
  if (!hasRole(requiredRole)) return <Navigate to="/home" replace />;
  return <Outlet />;
};

export default RoleProtectedRoute;
